import { Modal as AntModal, type ModalProps } from 'antd'

export type UiModalProps = ModalProps

// Wrapper Modal: bọc AntD Modal để features/pages không import trực tiếp 'antd'
// (hard-rule module-authoring #1). Pass-through, không thêm hành vi.
export default function UiModal(props: UiModalProps) {
  return <AntModal {...props} />
}

UiModal.confirm = AntModal.confirm
UiModal.info = AntModal.info
UiModal.success = AntModal.success
UiModal.error = AntModal.error
UiModal.warning = AntModal.warning
UiModal.useModal = AntModal.useModal
